// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/TCCC-UnityHeadline-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/TCCC-UnityHeadline-Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-weight: 500;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

@font-face {
  font-weight: 700;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/typography.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAoE;AACtE;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAkE;AACpE","sourcesContent":["@font-face {\n  font-weight: 500;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Medium.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Bold.woff2') format('woff2');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
